import React, {PropsWithChildren} from 'react';
import {StyleProp, ViewStyle, View} from 'react-native';
import Svg, { Defs, Rect, LinearGradient, Stop } from 'react-native-svg';

type SectionProps = PropsWithChildren<{
  fromColor:string,
  toColor: string,
  children: React.ReactNode,
  style?: StyleProp<ViewStyle>
}>;

function BackgroundLinear({fromColor, toColor, children, style}:SectionProps): JSX.Element {
  let id = `${fromColor}-${toColor}-${Math.floor(Math.random() * 1000)}`;
  return (
    <View style={style}>
      <Svg height="100%" width="100%" style={{position: 'absolute', right: 0, left: 0}}>
        <Defs>
            <LinearGradient id={id} x1="0%" y1="0%" x2="0%" y2="100%">
                <Stop offset="0" stopColor={ fromColor }/>
                <Stop offset="1" stopColor={ toColor }/>
            </LinearGradient>
        </Defs>
        <Rect width="100%" height="100%" fill={`url(#${id})`} />
      </Svg>
        {children}
    </View>
  );
}
export default BackgroundLinear;
